import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type NoteFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const NoteFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: NoteFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-6.799953 -6.799992) scale(0.783333)',
        },
        [
          h(
            'path',
            {
              d: 'M33.4349 11.1429C34.0106 11.6759 34.469 12.1183 34.8102 12.4701C35.1513 12.822 35.4125 13.1205 35.5938 13.3657C35.775 13.6109 35.8869 13.8188 35.9296 13.9893C35.9722 14.1599 35.9936 14.3092 35.9936 14.4371V14.9488H31.2601C31.0469 14.9488 30.8603 14.8689 30.7004 14.709C30.5405 14.549 30.4072 14.3625 30.3006 14.1493C30.194 13.936 30.114 13.7175 30.0607 13.4936C30.0074 13.2697 29.9808 13.0938 29.9808 12.9659V9H30.0767C30.2473 9 30.4232 9.02665 30.6044 9.07996C30.7857 9.13326 30.9936 9.23454 31.2281 9.3838C31.4626 9.53305 31.7558 9.74627 32.1076 10.0235C32.4594 10.3006 32.9019 10.6738 33.4349 11.1429ZM27.9658 12.9979C27.9658 13.4243 28.0298 13.8667 28.1577 14.3252C28.2857 14.7836 28.4882 15.21 28.7654 15.6045C29.0426 15.9989 29.3944 16.3241 29.8208 16.58C30.2473 16.8358 30.7484 16.9638 31.324 16.9638H35.9936V35.0021C35.9936 35.6205 35.871 36.1748 35.6257 36.6652C35.3805 37.1556 35.0554 37.5714 34.6503 37.9126C34.2452 38.2537 33.7974 38.5203 33.307 38.7122C32.8166 38.904 32.3368 39 31.8678 39H16.1321C15.727 39 15.2846 38.8827 14.8049 38.6482C14.3251 38.4136 13.8773 38.1045 13.4616 37.7207C13.0458 37.3369 12.6993 36.8998 12.4221 36.4094C12.1449 35.919 12.0063 35.4072 12.0063 34.8742V13.1258C12.0063 12.678 12.1076 12.2143 12.3102 11.7345C12.5127 11.2548 12.7899 10.8124 13.1417 10.4072C13.4936 10.0021 13.8933 9.66631 14.3411 9.39979C14.7889 9.13326 15.2579 9 15.7484 9H27.9658V12.9979ZM29.9808 32.9552C30.5351 32.9552 31.0042 32.758 31.388 32.3635C31.7718 31.9691 31.9637 31.4947 31.9637 30.9403C31.9637 30.3859 31.7718 29.9168 31.388 29.533C31.0042 29.1493 30.5351 28.9574 29.9808 28.9574H17.9872C17.4328 28.9574 16.9637 29.1493 16.5799 29.533C16.1961 29.9168 16.0042 30.3859 16.0042 30.9403C16.0042 31.4947 16.1961 31.9691 16.5799 32.3635C16.9637 32.758 17.4328 32.9552 17.9872 32.9552H29.9808ZM31.9637 22.9765C31.9637 22.4222 31.7718 21.9478 31.388 21.5533C31.0042 21.1588 30.5351 20.9616 29.9808 20.9616H17.9872C17.4328 20.9616 16.9637 21.1588 16.5799 21.5533C16.1961 21.9478 16.0042 22.4222 16.0042 22.9765C16.0042 23.5309 16.1961 24 16.5799 24.3838C16.9637 24.7676 17.4328 24.9595 17.9872 24.9595H29.9808C30.5351 24.9595 31.0042 24.7676 31.388 24.3838C31.7718 24 31.9637 23.5309 31.9637 22.9765Z',
            },
          ),
        ],
      ),
    ],
  );

export default NoteFilled;
